import { createAsyncThunk } from '@reduxjs/toolkit'
import { getProductModifiers, putProductModifier } from 'features/Product/services/modifier'
import { callErrorMsg } from 'helpers/errorMsg'
import { getCleanQueryObj } from 'utils/queryParamsURL'
import { Product } from 'features/Product/@types'
import { getProducts } from 'features/Product/services/product'
import { toastSuccess } from 'utils/toast'
import { SLICE_NAME, setIsLoading, setModifierConnectionData, setProductData } from './slice'

export const fetchProductModifiers = createAsyncThunk<void, boolean>(
  `${SLICE_NAME}/fetchProductModifiers`,
  async (_refetchAll, { getState, dispatch }) => {
    const {
      modifierConnection: { query },
    } = getState() as StoreStateType

    dispatch(setIsLoading(true))

    try {
      const { data: product } = await getProducts(
        getCleanQueryObj(query) as Partial<Product.QueryType>,
      )
      const { data, pagination } = product

      const productModifierResponses = await Promise.all(
        data.map((item) => getProductModifiers({ search: item.productSkuNo, page_size: 50 })),
      )

      const combinedModifierData = productModifierResponses.flatMap((res) => res.data.data)
      dispatch(
        setModifierConnectionData({
          pagination: productModifierResponses[0]?.data.pagination ?? null,
          data: combinedModifierData,
        }),
      )

      const productPayload = data.map((item, idx) => {
        const productModifierMatch = productModifierResponses[idx].data.data.find(
          (modifier) => modifier.product.product_id === item.productID,
        )

        return {
          ...item,
          modifiers: productModifierMatch?.modifiers.filter(({ is_active }) => is_active) || [],
        }
      })

      dispatch(setProductData({ pagination, data: productPayload }))
    } catch (err) {
      callErrorMsg(err)
    } finally {
      dispatch(setIsLoading(false))
    }
  },
)

export const updateProductModifier = createAsyncThunk(
  `${SLICE_NAME}/updateProductModifier`,
  async (_, { getState }) => {
    const {
      modifierConnection: { selectedProduct, selectedModifiers },
    } = getState() as StoreStateType

    const payload = {
      modifiers: selectedModifiers.map(({ id }) => ({ id })),
    }

    try {
      const {
        data: { message },
      } = await putProductModifier(selectedProduct?.productID as number, payload)

      toastSuccess(message)
      return true
    } catch (err) {
      callErrorMsg(err)
      return false
    }
  },
)
